module.exports = __webpack_public_path__ + "media/point-1.5f7b42dd.wav";